import { closeModalAction, openCustomModal, openTextModalAction } from "../../actions/modal";
import { deleteTeamAction } from "../../actions/teams";
import { transformTab } from "../../reducers/partners";
import EditTeam from "./Modals/EditTeam";
import LinkProjects from "./Modals/LinkProjects";


const getTabFromQueryString = (tabs, urlQueryString) => {
    const match = urlQueryString.match(/[\?&]tab=(\w+)/);
    let queryTab;
    if (match) queryTab = match[1];
    const matchingTab = tabs.find((tab) => tab.path === queryTab);
    if (matchingTab) return { matchingTab };
    return {};
};


export const getTabsList = (rolesList, userTabs, is_scm) => {
    if (Array.isArray(rolesList) && Array.isArray(userTabs)) {
        let orderedTabs = [];

        // Process tabs in the order they appear in userTabs
        for (const userTab of userTabs) {
            const tabKey = userTab.key.toLowerCase();
            if (tabKey === 'all' && is_scm) {
                orderedTabs.push(transformTab(allusersTab));
                continue;
            }

            if (tabKey === 'verification_pending' && is_scm) {
                orderedTabs.push(transformTab(verificationPendingTab));
                continue;
            }

            if (tabKey === 'teams') {
                orderedTabs.push(transformTab(teamsTab));
                continue;
            }

            if (tabKey === 'clients' && is_scm) {
                orderedTabs.push(transformTab(clientsTab));
                continue;
            }

            // Add matching role-based tabs
            const matchingRole = rolesList.find(role =>
                role.label.toLowerCase() === tabKey
            );
            if (matchingRole) {
                orderedTabs.push(matchingRole);
            }
        }

        return orderedTabs;
    }
    return [];
};

export const getTeamsDefaultTab = (tabs, userTabs, { urlQueryString }) => {
    let tabsList = getTabsList(tabs, userTabs);
    if (tabsList.length > 0) {
        let tab = tabsList[0];
        if (urlQueryString) {
            const { matchingTab } = getTabFromQueryString(tabs, urlQueryString);
            if (matchingTab) {
                tab = matchingTab;
            }
        }
        return tab?.path;
    }
    return '';
};


export const clientsTab = { id: 'clients', path: 'clients', label: 'Clients', _id: 'clients' };
export const verificationPendingTab = { id: 'verification_pending', path: 'verification_pending', _id: 'verification_pending', label: 'Verification Pending' };
export const teamsTab = { id: 'teams', path: 'teams', _id: 'teams', label: 'Teams' };
export const allusersTab = { id: 'all', path: 'all', _id: 'all', label: 'All' };

export const canViewTabs = Object.freeze({
    can_view_child_orgs: 'can_view_child_orgs'
});

export const defaultLimit = 48;


const editTeam = {
    key: 'editTeam',
    menuName: 'Edit Team',
    menuIcon: 'edit',
    iconColor: 'text-black',
    onClick: (item, dispatch) => {
        return dispatch(
            openCustomModal({
                heading: 'Edit Team Name',
                modalWidth: '50rem',
                modalHeight: 'auto',
                modalComponent: <EditTeam teamDetails={item} />,
            })
        );
    },
};


const deleteTeam = {
    key: 'deleteTeam',
    menuName: 'Delete Team',
    menuIcon: 'delete',
    iconColor: 'text-scogoclosed',
    formName: 'deleteTeam',
    onClick: (item, dispatch, { }) => {
        return dispatch(
            openTextModalAction({
                heading: 'Delete Team',
                text: 'Are you sure you want to continue?',
                closeOnBackdropClick: false,
                formName: 'deleteTeam',
                buttons: [
                    {
                        showLoading: true,
                        textOrComponent: 'Yes',
                        type: 'red',
                        onClick: () => {
                            dispatch(deleteTeamAction({ teamId: item.id, teamName: item.name, formName: 'deleteTeam' }));
                        },
                    },
                    {
                        textOrComponent: 'No',
                        type: 'blue',
                        onClick: () => {
                            dispatch(closeModalAction());
                        },
                    },
                ],
            })
        );
    },
};


const linkProjects = {
    key: 'linkProjects',
    menuName: 'Link Projects',
    menuIcon: 'list_alt',
    iconColor: 'text-black',
    onClick: (team, dispatch) => {
        return dispatch(
            openCustomModal({
                heading: `Link Projects to ${team.name}`,
                modalWidth: '60rem',
                modalHeight: 'auto',
                modalComponent: <LinkProjects team={team} />,
            })
        );
    },
};

const linkedTeamProjects = {
    key: 'linkedTeamProjects',
    menuName: 'Linked Projects',
    menuIcon: 'article',
    iconColor: 'text-scogoorange',
    onClick: (item, dispatch, { onLinkedTeamProjectClick }) => {
        onLinkedTeamProjectClick(item)
    },
};


export const TeamsActionsEnum = {
    EDIT_TEAM: 'EDIT_TEAM',
    DELETE_TEAM: 'DELETE_TEAM',
    ADD_MEMBER: 'ADD_MEMBER',
    REMOVE_MEMBER: 'REMOVE_MEMBER',
    PROMOTE_MEMBER: 'PROMOTE_MEMBER',
}


export const canEditTeam = (actions = []) => {
    const hasPermission = actions.find(({ action }) => action === TeamsActionsEnum.EDIT_TEAM);
    return (!hasPermission || hasPermission && hasPermission.allowed);
}

export const canDeleteTeam = (actions = []) => {
    const hasPermission = actions.find(({ action }) => action === TeamsActionsEnum.DELETE_TEAM);
    return (!hasPermission || hasPermission && hasPermission.allowed);
}

export const canAddUsersToTeam = (actions = []) => {
    const hasPermission = actions.find(({ action }) => action === TeamsActionsEnum.ADD_MEMBER);
    return (!hasPermission || hasPermission && hasPermission.allowed);
}

export const canRemoveUsersFromTeam = (actions = []) => {
    const hasPermission = actions.find(({ action }) => action === TeamsActionsEnum.REMOVE_MEMBER);
    return (!hasPermission || hasPermission && hasPermission.allowed);
}

export const getTeamsActions = (team) => {
    let actions = [editTeam, deleteTeam, linkProjects, linkedTeamProjects];
    return actions.filter((action) => {
        switch (action.key) {

            case editTeam.key:
            case linkProjects.key:
            case linkedTeamProjects.key:
                return canEditTeam(team.actions);

            case deleteTeam.key:
                return canDeleteTeam(team.actions);


            default:
                return true;
        }
    });
}